import { TextField } from '@mui/material';
import { Controller } from 'react-hook-form';
import { FormFieldProps } from '../../../../../type/manage';

const FormTextField = ({ name, label, control, ...props }: FormFieldProps) => (
  <Controller 
    name={name} 
    control={control} 
    render={({ field }) => <TextField {...field} fullWidth size="small" label={label} {...props} />} 
  />
);

export default FormTextField;